module.exports = __webpack_public_path__ + "img/14.b0594a15.jpg";